import css from './ExtraGoods.module.scss'
import React from 'react'

import { IEventDetails } from 'meta/backendControlled/structure'
import { Breakpoints } from 'meta/layout/breakpoints'
import { ITicket } from 'meta/pages/tickets'

import { GridColumn } from 'components/Layout/Grid'

import TicketFormFields from '../Ticket/TicketFormFields'
import { ITicketsFormFields } from '../types'
import EventInfo from './EventInfo'
import GoodInfo from './GoodInfo'

interface IPropsTicket {
  formFields: ITicketsFormFields
  idx: number
  tickets: ITicket[]
  event: IEventDetails
}

const ExtraGoods: React.FC<IPropsTicket> = (props) => {
  const { formFields, idx, tickets, event } = props

  return (
    <GridColumn
      className={css.container}
      id={`${idx}_${tickets[0].id}`}
      gridColumnStart={{ [Breakpoints.mobile]: 1, [Breakpoints.tablet]: 4, [Breakpoints.laptop]: 4 }}
      gridColumnEnd={{ [Breakpoints.mobile]: 17, [Breakpoints.tablet]: 14, [Breakpoints.laptop]: 14 }}
    >
      <div className={css.ticket__content}>
        <EventInfo event={event} />
        <GoodInfo event={event} tickets={tickets} />
        <TicketFormFields formFields={formFields} idx={idx} ticket={tickets[0]} noPadding />
      </div>
    </GridColumn>
  )
}

export default ExtraGoods
